/**
 * Normalise un libellé pour l'affichage (null, chaîne vide, "null" → undefined).
 */
export function useFormatLabel() {
  function formatLabel(value: string | null | undefined): string | undefined {
    if (value == null || value === '' || String(value).toLowerCase() === 'null') return undefined
    return value
  }
  return { formatLabel }
}
